import { LunaError } from '@vlabs/api-bindings/src/luna-client/LunaError';
import axios from 'axios';

import { showAPIErrorToast } from './APIErrorToast';
import { showErrorToast } from './ErrorToast';
import { showLunaErrorToast } from './LunaErrorToast';

export function handleError(error) {
  console.error(error);
  if (error instanceof LunaError) {
    showLunaErrorToast(error);
  } else if (axios.isAxiosError(error)) {
    showAPIErrorToast(error);
  } else if (error instanceof Error) {
    showErrorToast(error);
  }
}
